import * as React from 'react';

import {Carousel, Skeleton} from 'antd';

import {useHistory, useLocation} from 'react-router-dom';

import {getBackgroundUrl} from '@common/typescript/Utils';

import SliderAreaVet from '@app/components/UI/Slider/SliderAreaVet';
import {getImagePath} from '@app/objects/Image';

const arrowIcon = require('@app/images/arrow_circle.svg');
const arrowIconHovered = require('@app/images/button_slider.svg');

const SliderAvatar: React.FC<any> = ({item, i, currentIndex, onClick}) => {
	const avatarHeight = 236;
	const avatarWidth = 236;

	return(
		<div
			key={`dot-${item.id}`}
			onClick={onClick}
			className={`slider-area-vets__avatars-item ${currentIndex === i ? 'active' : ''}`}
		>
			<div
				className="slider-area-vets__avatar"
				style={{backgroundImage: getBackgroundUrl(getImagePath(item.avatar, avatarHeight, avatarWidth))}}
			/>
			<span className="slider-area-vets__name">Dr. {item.firstName}</span>
		</div>
	);
};

const SliderAreaVetCarousel: React.FC<any> = ({sliderItems}) => {

	const slider = React.useRef<any>();
	const sliderAvatar = React.useRef<any>(null);

	const [currentIndex, setCurrentIndex] = React.useState(0);
	const history = useHistory();
	const location = useLocation();
	const tabUrl = location.pathname;
	const initialVetId: number | undefined = location?.state?.currentVetId || Number(new URLSearchParams(location?.search)?.get('veterinarian'));
	const findCurrentVet = (list) => {
		const queryVetIndex = list.findIndex((el, i, arr) => el.id === initialVetId);
		// need to find better solution to set initial veterinarian-slide when redirect from home page
		setTimeout(() => {
			setCurrentIndex(queryVetIndex);
		}, 500);
	};

	React.useEffect(() => {
		if (sliderItems.length && initialVetId) {
			findCurrentVet(sliderItems);
		}
	}, [sliderItems]);

	React.useEffect(() => {
		sliderItems.length && history.push(`${tabUrl}?veterinarian=${sliderItems[currentIndex]?.id}`);
		sliderAvatar.current.goTo(currentIndex);
	}, [currentIndex, sliderAvatar]);

	return(
		<div className="slider-area-vets">
			<div className="slider-area-vets__top">
				<div className="slider-area-vets__avatars">
					<Carousel
						ref={sliderAvatar}
						asNavFor={slider.current!}
						slidesToShow={5}
						// centerMode={true
						swipeToSlide={true}
						swipe={true}
						infinite={sliderItems.length > 5}
						dots={false}
						variableWidth={true}
						rows={1}
						slidesPerRow={1}
						responsive={[
							{
								breakpoint: 1100,
								settings: {
									slidesToShow: 3
								}
							},
							{
								breakpoint: 470,
								settings: {
									slidesToShow: 2
								}
							}
						]}
					>
						{sliderItems.map((item, i) => (
							<SliderAvatar
								item={item}
								i={i}
								currentIndex={currentIndex}
								key={item.id}
								onClick={(e) => {
									setCurrentIndex(i);
								}}
							/>
						))}

					</Carousel>
				</div>
				{sliderItems.length > 5 &&
					<div className="slider-buttons slider-area-vets__button-wrapper">
						<div className="slider-button__wrapper">
							<img
								className="slider-button"
								src={arrowIcon}
								alt="Next"
								onClick={() => {
									slider.current!.next();
									sliderAvatar.current!.next();
								}}
							/>
							<img
								className="slider-button slider-button_hovered"
								src={arrowIconHovered}
								alt="Next"
								onClick={() => {
									slider.current!.next();
									sliderAvatar.current!.next();
								}}
							/>
						</div>
					</div>
				}
			</div>
			<div className="slider-area-vets__body">
				{(!sliderItems.length) ? <Skeleton title={false} paragraph={{ rows: 1, className: 'slider-tes-skeleton' }} active/> :
					<Carousel
						ref={slider}
						asNavFor={sliderAvatar.current.slick}
						slidesToShow={1}
						lazyLoad="ondemand"
						afterChange={setCurrentIndex}
						dots={false}
						infinite
						effect="fade"
					>
						{sliderItems.map(item => (
							<SliderAreaVet vet={item} key={item.id}/>
						))}

					</Carousel>
				}
			</div>
		</div>
	);
};

export default SliderAreaVetCarousel;